import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, colors } from "../shared/constants";
import { styles, inputStyle } from "../shared/styles";

export function NewEFSMRow({ siteId, onSave }) {
  const [showForm, setShowForm] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isMonthly, setIsMonthly] = useState(false);
  const [isBiAnnual, setIsBiAnnual] = useState(false);
  const [isAnnual, setIsAnnual] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/asset-categories/`)
      .then((res) => setCategories(res.data))
      .catch(() => {});
  }, []);

  const handleSave = async () => {
    if (!selectedCategory) {
      setError("Please select a measure.");
      return;
    }
    if (!isMonthly && !isBiAnnual && !isAnnual) {
      setError("Select at least one frequency.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await axios.post(`${API}/site-efsms/`, {
        site: siteId,
        category: parseInt(selectedCategory),
        is_monthly: isMonthly,
        is_bi_annual: isBiAnnual,
        is_annual: isAnnual,
      });
      setSelectedCategory("");
      setIsMonthly(false);
      setIsBiAnnual(false);
      setIsAnnual(false);
      onSave();
    } catch (e) {
      setError("Save failed.");
    }
    setSaving(false);
  };

  if (!showForm) {
    return (
      <div style={{ padding: "10px 20px" }}>
        <button
          onClick={() => setShowForm(true)}
          style={{
            ...styles.addButton,
            padding: "8px 16px",
            fontSize: "13px",
            backgroundColor: "#5a9c78",
            boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
          }}
        >
          + Add EFSM
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#f0faf0",
        borderTop: `2px solid ${colors.green}`,
      }}
    >
      <div
        style={{
          padding: "6px 20px 2px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <span
          style={{
            fontSize: "11px",
            fontWeight: "700",
            color: colors.green,
            textTransform: "uppercase",
          }}
        >
          + New EFSM
        </span>
        <span
          onClick={() => setShowForm(false)}
          style={{ fontSize: "11px", color: "#94a3b8", cursor: "pointer" }}
        >
          Cancel
        </span>
        {error && (
          <span style={{ fontSize: "11px", color: colors.red }}>{error}</span>
        )}
        {saving && (
          <span style={{ fontSize: "11px", color: colors.blue }}>
            Saving...
          </span>
        )}
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr 1fr 80px",
          padding: "6px 20px 10px",
          gap: "8px",
          alignItems: "center",
        }}
      >
        <select
          style={{ ...inputStyle, fontSize: "13px", padding: "4px 6px" }}
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">— Select measure —</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
        <label
          style={{
            fontSize: "13px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <input
            type="checkbox"
            checked={isMonthly}
            onChange={(e) => setIsMonthly(e.target.checked)}
          />
          Monthly
        </label>
        <label
          style={{
            fontSize: "13px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <input
            type="checkbox"
            checked={isBiAnnual}
            onChange={(e) => setIsBiAnnual(e.target.checked)}
          />
          Bi-Annual
        </label>
        <label
          style={{
            fontSize: "13px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <input
            type="checkbox"
            checked={isAnnual}
            onChange={(e) => setIsAnnual(e.target.checked)}
          />
          Annual
        </label>
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            ...styles.addButton,
            padding: "6px 12px",
            fontSize: "12px",
            backgroundColor: "#5a9c78",
            boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
          }}
        >
          Add
        </button>
      </div>
    </div>
  );
}
